var _defs, _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSemaforo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 71",
    width: 320,
    height: 71,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Academico") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "cp1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m320 69.72h-320l3.15-69.72 316.85 4.56v65.16z"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #e8bb7e } \n\t\t.s1 { fill: #f2c38c } \n\t\t.s2 { fill: #f7d19a } \n\t\t.s3 { fill: #d8a568 } \n\t\t.s4 { opacity: .3;mix-blend-mode: multiply;fill: #212121 } \n\t\t.s5 { fill: #414042 } \n\t\t.s6 { fill: #353535 } \n\t\t.s7 { fill: #6d6e71 } \n\t\t.s8 { fill: #542e09 } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Capa_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_2-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "s0",
    d: "m320 67.4l-320 2.3 3.1-69.7 316.9 4.6v62.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s1",
    d: "m319.8 42l-319-3 2.3-39 316.9 4.6-0.2 37.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s2",
    d: "m3.1 0v1.4l316.9 3.2v-1.1l-316.8-3.5z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clip-Path",
    clipPath: "url(#cp1)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "s3",
    d: "m322.1 3.8l-9.2 3.4-16.9 0.3-19.6-1.9-12 0.2-17.4-2-27.4 2.6-51.7-1.4-14.1 0.3-13.9 2.4-23.1-1.9-15.3 2.4-2.7-0.9-9.9-3.3-11.6 0.2-9.2 2.4-17.8 0.2-11.1-2-12 0.2-25.2 4.8 27.9-1.6 13.4 1.2 26.7 1.5 12.3-4.9 27.4 4.3 7.1-3.4 16.2 3 16.6-0.2 6.5-2 11.9-1.6 12.4 3.1 12.1-0.2 19.7-0.3 12.8-0.2 12.4-0.1 10.2-2.1 9.8 1.7 7.1-0.1 7.5-0.1 12.5-0.2 11.1 2.1 13.4-0.3 7.1-0.1 6-5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s3",
    d: "m-7 21.4l14.1-3.4 25.8-0.3 29.8 2 18.3-0.2 26.5 2 41.9-2.6 78.8 1.5 21.5-0.2 21.3-2.4 35.2 1.9 23.5-2.4 4.1 0.9 14.9 3.3 17.7-0.2 14.1-2.3 27.1-0.2 17 2 18.3-0.2 38.6-4.7-42.7 1.5-20.4-1.2-40.6-1.5-18.9 4.8-41.7-4.3-11 3.4-24.6-3.1-25.3 0.3-9.9 1.9-18.2 1.6-19-3.1-18.3 0.1-30.2 0.3-19.4 0.2-19 0.2-15.5 2-15-1.8-10.8 0.1-11.5 0.1-19 0.2-17-2-20.3 0.1-10.9 0.1-9.3 5.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s3",
    d: "m-135.2 25.1l14.1 3.4 25.8 0.2 29.8-2 18.3 0.1 26.5-2 42 2.5 78.7-1.6 21.6 0.2 21.2 2.3 35.2-1.9 23.5 2.4 4.1-0.9 14.9-3.4 17.7 0.2 14.2 2.3 27.1 0.2 16.9-2.1 18.3 0.1 38.6 4.7-42.7-1.4-20.3 1.2-40.7 1.6-18.9-4.8-41.6 4.4-11.1-3.4-24.6 3.1-25.3-0.2-9.9-1.9-18.2-1.6-18.9 3.2-18.4-0.2-30.2-0.2-19.4-0.1-19-0.2-15.5-2-15 1.8-10.8-0.1-11.5-0.1-19-0.1-17 2-20.3-0.1-10.8-0.1-9.4-5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s3",
    d: "m322.1 66l-9.2-3.5-16.9-0.2-19.6 1.9-12-0.2-17.4 1.9-27.4-2.6-51.7 1.4-14.1-0.2-13.9-2.4-23.1 1.8-15.3-2.4-2.7 0.9-9.9 3.3-11.6-0.2-9.2-2.3-17.8-0.3-11.1 2-12-0.2-25.2-4.7 27.9 1.5 13.4-1.2 26.7-1.5 12.3 4.9 27.4-4.3 7.1 3.4 16.2-3 16.6 0.2 6.5 2 11.9 1.6 12.4-3.1 12.1 0.2 19.7 0.3 12.8 0.2 12.4 0.2 10.2 2 9.8-1.7 7.1 0.1 7.5 0.1 12.5 0.2 11.1-2 13.4 0.2 7.1 0.1 6 5.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s3",
    d: "m-7 48.4l14.1 3.4 25.8 0.2 29.8-1.9 18.3 0.1 26.5-1.9 41.9 2.5 78.8-1.4 21.5 0.1 21.3 2.4 35.2-1.9 23.5 2.4 4.1-0.9 14.9-3.3 17.7 0.2 14.1 2.3 27.1 0.3 17-2.1 18.3 0.2 38.6 4.7-42.7-1.5-20.4 1.2-40.6 1.5-18.9-4.8-41.7 4.3-11-3.4-24.6 3.1-25.3-0.2-9.9-2-18.2-1.6-19 3.1-18.3-0.1-30.2-0.3-19.4-0.1-19-0.2-15.5-2-15 1.7-10.8-0.1-11.5-0.1-19-0.2-17 2.1-20.3-0.2-10.9-0.1-9.3-5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s3",
    d: "m-19.4 44.6l14.1-3.3 25.8-0.2 29.8 1.9 18.3-0.1 26.5 2 42-2.5 78.7 1.6 21.6-0.2 21.2-2.3 35.3 1.9 23.4-2.4 4.1 1 15 3.3 17.6-0.2 14.2-2.2 27.1-0.2 16.9 2 18.4-0.1 38.5-4.7-42.7 1.4-20.3-1.2-40.7-1.6-18.9 4.8-41.6-4.3-11 3.3-24.6-3.1-25.4 0.2-9.9 2-18.2 1.5-18.9-3.1-18.4 0.1-30.2 0.2-19.4 0.2-19 0.1-15.5 2-14.9-1.8-10.9 0.1-11.5 0.1-19 0.1-17-2-20.3 0.1-10.8 0.1-9.4 5.5z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "s3",
    d: "m0 69.7l320-2.3v1.2l-320 2.4v-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s4",
    d: "m16.7 8.9c0 2.4-2 5-4.3 5-2.4 0-4.4-2.6-4.4-5 0-2.4 2-4.3 4.4-4.3 2.3 0 4.3 1.9 4.3 4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s5",
    d: "m16.7 8.9c0 2.4-2 4.3-4.3 4.3-2.4 0-4.4-1.9-4.4-4.3 0-2.4 2-4.3 4.4-4.3 2.3 0 4.3 1.9 4.3 4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "m12.4 10.9c-1.6 0-2.6-0.9-3.1-2h-0.1c0 1.7 1.4 3.5 3.1 3.5 1.8 0 3.1-1.8 3.2-3.5-0.5 1.2-1.5 2-3.1 2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s5",
    d: "m15.5 8.9c0 1.7-1.4 3.1-3.1 3.1-1.8 0-3.2-1.4-3.2-3.1 0-1.7 1.4-3.1 3.2-3.1 1.7 0 3.1 1.4 3.1 3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m14.6 6.7q0.4 0.6 0.4 1.4c0 1.5-1.2 2.7-2.6 2.7-1.5 0-2.7-1.2-2.7-2.7q0-0.8 0.4-1.4c-0.5 0.6-0.9 1.3-0.9 2.2 0 1.7 1.4 3.1 3.1 3.1 1.8 0 3.2-1.4 3.2-3.1 0-0.9-0.4-1.6-0.9-2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s4",
    d: "m314 12.9c0 2.4-1.9 5-4.3 5-2.4 0-4.3-2.6-4.3-5 0-2.4 1.9-4.3 4.3-4.3 2.4 0 4.3 1.9 4.3 4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s5",
    d: "m314 12.9c0 2.4-1.9 4.3-4.3 4.3-2.4 0-4.3-1.9-4.3-4.3 0-2.4 1.9-4.3 4.3-4.3 2.4 0 4.3 1.9 4.3 4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "m309.8 14.9c-1.6 0-2.7-0.9-3.1-2h-0.1c0 1.7 1.4 3.5 3.1 3.5 1.7 0 3.1-1.8 3.1-3.5-0.4 1.2-1.4 2-3 2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s5",
    d: "m312.9 12.9c0 1.7-1.4 3.1-3.2 3.1-1.7 0-3.1-1.4-3.1-3.1 0-1.7 1.4-3.1 3.1-3.1 1.8 0 3.2 1.4 3.2 3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m311.9 10.7q0.5 0.6 0.5 1.4c0 1.5-1.2 2.7-2.7 2.7-1.4 0-2.6-1.2-2.6-2.7q0-0.8 0.4-1.4c-0.6 0.6-0.9 1.3-0.9 2.2 0 1.7 1.4 3.1 3.1 3.1 1.8 0 3.1-1.4 3.1-3.1 0-0.9-0.3-1.6-0.8-2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s4",
    d: "m314 59.6c0 2.4-1.9 5-4.3 5-2.4 0-4.3-2.6-4.3-4.9 0-2.4 1.9-4.4 4.3-4.4 2.4 0 4.3 2 4.3 4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s5",
    d: "m314 59.6c0 2.4-1.9 4.4-4.3 4.4-2.4 0-4.3-2-4.3-4.4 0-2.3 1.9-4.3 4.3-4.3 2.4 0 4.3 2 4.3 4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "m309.8 61.7c-1.6 0-2.7-0.9-3.1-2h-0.1c0 1.7 1.4 3.5 3.1 3.5 1.7 0 3.1-1.8 3.1-3.5-0.4 1.1-1.4 2-3 2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s5",
    d: "m312.9 59.6c0 1.8-1.4 3.2-3.2 3.2-1.7 0-3.1-1.4-3.1-3.2 0-1.7 1.4-3.1 3.1-3.1 1.8 0 3.2 1.4 3.2 3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m311.9 57.5q0.5 0.6 0.5 1.4c0 1.5-1.2 2.7-2.7 2.7-1.4 0-2.6-1.2-2.6-2.7q0-0.8 0.4-1.4c-0.6 0.5-0.9 1.3-0.9 2.2 0 1.7 1.4 3.1 3.1 3.1 1.8 0 3.1-1.4 3.1-3.1 0-0.9-0.3-1.7-0.8-2.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s4",
    d: "m13.5 60c0 2.4-1.9 5-4.3 5-2.4 0-4.3-2.6-4.3-5 0-2.4 1.9-4.3 4.3-4.3 2.4 0 4.3 1.9 4.3 4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s5",
    d: "m13.5 60c0 2.4-1.9 4.3-4.3 4.3-2.4 0-4.3-1.9-4.3-4.3 0-2.4 1.9-4.3 4.3-4.3 2.4 0 4.3 1.9 4.3 4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s6",
    d: "m9.3 62c-1.6 0-2.7-0.9-3.1-2h-0.1c0 1.7 1.4 3.5 3.1 3.5 1.7 0 3.1-1.8 3.1-3.5-0.4 1.2-1.4 2-3 2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s5",
    d: "m12.3 60c0 1.7-1.4 3.1-3.1 3.1-1.7 0-3.1-1.4-3.1-3.1 0-1.8 1.4-3.2 3.1-3.2 1.8 0 3.2 1.4 3.1 3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "s7",
    d: "m11.4 57.8q0.5 0.6 0.5 1.4c0 1.5-1.2 2.7-2.7 2.7-1.4 0-2.6-1.2-2.6-2.7q0-0.8 0.4-1.4c-0.6 0.6-0.9 1.3-0.9 2.2 0 1.7 1.4 3.1 3.1 3.1 1.7 0 3.1-1.4 3.1-3.1 0-0.9-0.3-1.6-0.9-2.2z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "SEM\\xC1FORO",
    className: "s8",
    "aria-label": "SEM\\xC1FORO",
    d: "m81.3 39.9c0-8.6-12.5-5.9-12.5-10.8 0-1.9 1.4-2.9 3.4-2.8 2.1 0 3.4 1.3 3.5 2.9h5.4c-0.4-4.4-3.8-7-8.8-7-5 0-8.6 2.7-8.6 7.1 0 8.8 12.6 5.7 12.6 10.9 0 1.8-1.4 3-3.7 3-2.3 0-3.6-1.3-3.7-3.2h-5.3c0.1 4.6 4 7.2 9.1 7.2 5.6 0 8.6-3.4 8.6-7.3zm18.4-17.4h-14.1v24.5h14.1v-4h-9.2v-6.5h8.2v-3.9h-8.2v-6.1h9.2zm4.5 24.5h4.9v-15.9l6.6 15.9h3.7l6.5-15.9v15.9h4.9v-24.4h-5.5l-7.8 18.1-7.7-18.1h-5.6zm48 0h5.2l-8.8-24.5h-5.7l-8.7 24.5h5.1l1.6-4.7h9.7zm-10.7-29.3v3.5l8.1-3.7v-4zm7.7 20.8h-7l3.5-10.3zm11.4 8.6h4.9v-10.3h7.8v-3.9h-7.8v-6.3h10.2v-3.9h-15.1zm42.4-12.3c0-7.3-5.5-12.5-12.5-12.5-6.9 0-12.5 5.2-12.5 12.5 0 7.4 5.6 12.5 12.5 12.5 6.9 0 12.5-5.1 12.5-12.5zm-20 0c0-5 3.1-8.1 7.5-8.1 4.4 0 7.5 3.1 7.5 8.1 0 5-3.1 8.2-7.5 8.2-4.4 0-7.5-3.2-7.5-8.2zm36.6-4.5c0 2.2-1.2 3.6-4 3.6h-4.1v-7.2h4.1c2.8 0 4 1.4 4 3.6zm-13-7.6v24.4h4.9v-9.5h2.4l5.3 9.5h5.7l-5.8-9.9c3.9-1.1 5.5-4.1 5.5-7.1 0-4-2.9-7.4-8.8-7.4zm46.3 12.1c0-7.3-5.5-12.5-12.5-12.5-6.9 0-12.5 5.2-12.5 12.5 0 7.4 5.6 12.5 12.5 12.5 6.9 0 12.5-5.1 12.5-12.5zm-20 0c0-5 3-8.1 7.5-8.1 4.4 0 7.4 3.1 7.4 8.1 0 5-3 8.2-7.4 8.2-4.5 0-7.5-3.2-7.5-8.2z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSemaforo);
export default __webpack_public_path__ + "static/media/semaforo.b1f8b5e14b586dec3be1dade5cd3bc16.svg";
export { ForwardRef as ReactComponent };